<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'SkeletonClientGroupOverviewContainer',
  mixins: [baseMixin],
  props: {},
  data: () => {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<template>
  <div
    :class="[
      isMediumOrHigher ? 'mt-12 d-flex justify-space-between' : '',
      'h-100',
    ]"
  >
    <div
      v-if="isMediumOrHigher"
      :style="{ width: isMediumOrHigher ? '40%' : '100%' }"
      :class="[
        isMediumOrHigher ? 'mr-4' : 'mb-4',
        'cl-elevation- rounded-xl d-flex align-center justify-center v-100',
      ]"
      style="height: 500px !important; border: 1px solid #EFEFEF;"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <div
      :style="{ width: isMediumOrHigher ? '60%' : '100%' }"
      :class="[isMediumOrHigher ? 'ml-4' : 'mt-8']"
    >
      <v-skeleton-loader
        loading
        type="table"
        class="cl-elevation rounded-xl"
      ></v-skeleton-loader
    ></div>
  </div>
</template>
